import React from "react";
import _ from "lodash";
import { formatDate, plainString } from "../../lib/constant";
import "./AccountDetail.css";
import fallbackImg from "../../assets/images/dream-prize.jpeg";

const DrawDetails = ({ setselectedTab, data }) => {
  const getStatusBadge = (status) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower === 'won' || statusLower === 'winner') {
      return <span className="status-badge status-won"><i className="fas fa-trophy"></i> Won</span>;
    } else if (statusLower === 'pending' || statusLower === 'active') {
      return <span className="status-badge status-pending"><i className="fas fa-clock"></i> Pending</span>;
    } else if (statusLower === 'completed' || statusLower === 'drawn') {
      return <span className="status-badge status-completed"><i className="fas fa-check-circle"></i> Completed</span>;
    } else {
      return <span className="status-badge status-default">{status || 'N/A'}</span>;
    }
  };

  return (
    <div className="draw-details-container">
      <div className="draw-details-header">
        <div className="draw-details-title">
          <i className="far fa-gift"></i>
          <h3>My Draw Entries</h3>
        </div>
        <p className="draw-details-subtitle">Track all your draw participations and results</p>
      </div>

      {!_.isEmpty(data) ? (
        <div className="draw-entries-grid">
          {data?.map((item, index) => (
            <div className="draw-entry-card" key={item.id || index}>
              <div className="draw-entry-header">
                <span className="draw-entry-number">#{index + 1}</span>
                {getStatusBadge(item?.draw_status)}
              </div>

              <div className="draw-entry-image">
                <img
                  src={item?.lottery?.image || fallbackImg}
                  alt={item?.lottery?.name || "Draw"}
                  loading="lazy"
                  onError={(e) => { e.target.src = fallbackImg; }}
                />
              </div>

              <div className="draw-entry-content">
                <h4 className="draw-entry-name">{item?.lottery?.name || 'Draw'}</h4>
                <p className="draw-entry-description">
                  {plainString(item?.lottery?.lottery_detail) || 'No description available'}
                </p>
                
                <div className="draw-entry-details">
                  <div className="draw-entry-detail">
                    <span className="detail-label">
                      <i className="far fa-ticket-alt"></i> Quantity
                    </span>
                    <span className="detail-value">{item?.qty || 1}</span>
                  </div>
                  <div className="draw-entry-detail">
                    <span className="detail-label">
                      <i className="far fa-calendar-alt"></i> Start Date
                    </span>
                    <span className="detail-value">{formatDate(item?.lottery?.start_date)}</span>
                  </div>
                  <div className="draw-entry-detail">
                    <span className="detail-label">
                      <i className="far fa-calendar-check"></i> End Date
                    </span>
                    <span className="detail-value">{formatDate(item?.lottery?.expire_date)}</span>
                  </div>
                </div>
              </div>
              
              <div className="draw-entry-footer">
                <div className="draw-entry-coins">
                  <i className="fas fa-coins"></i>
                  <span>{item?.lottery?.buy_in || 0} Coins</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state-card">
          <div className="empty-state-icon">
            <i className="far fa-gift"></i>
          </div>
          <h4>No Draw Entries Yet</h4>
          <p>You haven't participated in any draws yet. Explore our exciting draws and try your luck!</p>
          <a href="/" className="empty-state-btn">
            <i className="far fa-search"></i> Explore Draws
          </a>
        </div>
      )}
    </div>
  );
};

export default DrawDetails;
